import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem('saai_admin');
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      const { token, admin: adminData } = res.data;
      localStorage.setItem('saai_token', token);
      localStorage.setItem('saai_admin', JSON.stringify(adminData));
      setAdmin(adminData);
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || 'Login failed' };
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem('saai_token');
    localStorage.removeItem('saai_admin');
    setAdmin(null);
    window.location.href = '/admin/login';
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading, isAuth: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
